var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sh-signing-card',{ref:"signingCard",attrs:{"group-id":_vm.groupId,"invited-group-id":_vm.invitedGroupId,"process-uuid":_vm.processUuid,"event-uuid":_vm.eventUuid,"authentication-type":"access_token","download-base-url":_vm.downloadBaseUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }